import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 18px 16px;
  border: 1px solid ${theme.palette.border.light};
  border-radius: 8px;
`;
